import {getPosterUi} from '@PosterWhiteboard/ui/poster-ui';

export const isPageNavigationBlocked = (): boolean => {
  if (window.PMW.redux.store.getState().posterEditor.isDesktopTimelineToggleOn) {
    return true;
  }

  return getPosterUi().isPageNavigationBlockedByModal();
};
